import Styles from './Gradient.styled'

const Gradient = () => {
    return (
        <Styles className="gradient-wrapper" />
    )

}

export default Gradient